import { useState } from "react";
// import scheduleNull from "../Images/noschedules.svg";
import scheduleNull from "../Images/ImageToStl.com_noschedules.avif";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import { useEffect } from "react";
import { Box, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from "react-router-dom";
import activefill from "../Images/Active Full fill.png";
import fillgreen from "../Images/Active Full fill green.png";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../Loader";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Drawer from "rsuite/Drawer";
import nodata from "../Images/nothingfound.svg";
import { Tooltip } from "@mui/material";

export default function Schedule() {
  const history = useHistory();
  const [spinner, setSpinner] = useState(true);
  const [allSchedule, setAllSchedule] = useState([]);
  const [allScheduleCopy, setAllScheduleCopy] = useState([]);
  const [open3, setOpen3] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [selectedScheduleId, setSelectedScheduleId] = useState("");
  const [open, setOpen] = useState(false);
  const [shceduleName, setScheduleName] = useState("");
  const [mouseEntered, setMouseEntered] = useState("");
  const [mouseEntered2, setMouseEntered2] = useState("");
  const [selectedSchedule, setSelectedSchedule] = useState("");
  const [countryTimeSchedule, setCountryTimeSchdule] = useState(null);
  const [searchedVal, setSearchedVal] = useState("");
  const [daylistArr, setDayListArr] = useState([
    {
      Day: "Sunday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Monday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Tuesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Wednesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Thursday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Friday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Saturday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
  ]);
  const timeList = [
    "1:00 AM",
    "2:00 AM",
    "3:00 AM",
    "4:00 AM",
    "5:00 AM",
    "6:00 AM",
    "7:00 AM",
    "8:00 AM",
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 AM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
    "6:00 PM",
    "7:00 PM",
    "8:00 PM",
    "9:00 PM",
    "10:00 PM",
    "11:00 PM",
    "12:00 PM",
  ];
  const [showToaster, setShowToaster] = useState(false);
  const handleClose = () => {
    setOpen3(false);
    setScheduleName("");
    setCountryTimeSchdule(null);
  };
  const handleChange9 = (event, newValue) => {
    setCountryTimeSchdule(newValue);
  };
  const timezoneArr = [
    "(UTC-12:00) International Date Line West",
    "(UTC-11:00) Coordinated Universal Time-11",
    "(UTC-10:00) Hawaii",
    "(UTC-09:00) Alaska",
    "(UTC-08:00) Baja California",
    "(UTC-08:00) Pacific Time (US and Canada)",
    "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    "(UTC-07:00) Arizona",
    "(UTC-07:00) Mountain Time (US and Canada)",
    "(UTC-06:00) Central America",
    "(UTC-06:00) Central Time (US and Canada)",
    "(UTC-06:00) Saskatchewan",
    "(UTC-06:00) Guadalajara, Mexico City, Monterey",
    "(UTC-05:00) Bogota, Lima, Quito",
    "(UTC-05:00) Indiana (East)",
    "(UTC-05:00) Eastern Time (US and Canada)",
    "(UTC-04:30) Caracas",
    "(UTC-04:00) Atlantic Time (Canada)",
    "(UTC-04:00) Asuncion",
    "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    "(UTC-04:00) Cuiaba",
    "(UTC-04:00) Santiago",
    "(UTC-03:30) Newfoundland",
    "(UTC-03:00) Brasilia",
    "(UTC-03:00) Greenland",
    "(UTC-03:00) Cayenne, Fortaleza",
    "(UTC-03:00) Buenos Aires",
    "(UTC-03:00) Montevideo",
    "(UTC-02:00) Coordinated Universal Time-2",
    "(UTC-01:00) Cape Verde",
    "(UTC-01:00) Azores",
    "(UTC+00:00) Casablanca",
    "(UTC+00:00) Monrovia, Reykjavik",
    "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    "(UTC+00:00) Coordinated Universal Time",
    "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    "(UTC+01:00) West Central Africa",
    "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "(UTC+01:00) Windhoek",
    "(UTC+02:00) Athens, Bucharest, Istanbul",
    "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "(UTC+02:00) Cairo",
    "(UTC+02:00) Damascus",
    "(UTC+02:00) Amman",
    "(UTC+02:00) Harare, Pretoria",
    "(UTC+02:00) Jerusalem",
    "(UTC+02:00) Beirut",
    "(UTC+03:00) Baghdad",
    "(UTC+03:00) Minsk",
    "(UTC+03:00) Kuwait, Riyadh",
    "(UTC+03:00) Nairobi",
    "(UTC+03:30) Tehran",
    "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
    "(UTC+04:00) Tbilisi",
    "(UTC+04:00) Yerevan",
    "(UTC+04:00) Abu Dhabi, Muscat",
    "(UTC+04:00) Baku",
    "(UTC+04:00) Port Louis",
    "(UTC+04:30) Kabul",
    "(UTC+05:00) Tashkent",
    "(UTC+05:00) Islamabad, Karachi",
    "(UTC+05:30) Sri Jayewardenepura Kotte",
    "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "(UTC+05:45) Kathmandu",
    "(UTC+06:00) Astana",
    "(UTC+06:00) Dhaka",
    "(UTC+06:00) Yekaterinburg",
    "(UTC+06:30) Yangon",
    "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    "(UTC+07:00) Novosibirsk",
    "(UTC+08:00) Krasnoyarsk",
    "(UTC+08:00) Ulaanbaatar",
    "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "(UTC+08:00) Perth",
    "(UTC+08:00) Kuala Lumpur, Singapore",
    "(UTC+08:00) Taipei",
    "(UTC+09:00) Irkutsk",
    "(UTC+09:00) Seoul",
    "(UTC+09:00) Osaka, Sapporo, Tokyo",
    "(UTC+09:30) Darwin",
    "(UTC+09:30) Adelaide",
    "(UTC+10:00) Hobart",
    "(UTC+10:00) Yakutsk",
    "(UTC+10:00) Brisbane",
    "(UTC+10:00) Guam, Port Moresby",
    "(UTC+10:00) Canberra, Melbourne, Sydney",
    "(UTC+11:00) Vladivostok",
    "(UTC+11:00) Solomon Islands, New Caledonia",
    "(UTC+12:00) Coordinated Universal Time+12",
    "(UTC+12:00) Fiji, Marshall Islands",
    "(UTC+12:00) Magadan",
    "(UTC+12:00) Auckland, Wellington",
    "(UTC+13:00) Nuku'alofa",
    "(UTC+13:00) Samoa",
  ];
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  useEffect(() => {
    getShceduleData();
  }, []);

  useEffect(() => {
    const filteredRecords = allScheduleCopy.filter((row) =>
      row.Name.toLowerCase().includes(searchedVal.toLowerCase())
    );
    if (filteredRecords.length > 0) {
      setAllSchedule(filteredRecords);
    } else {
      setAllSchedule([]);
    }
  }, [searchedVal]);

  function convertTo24HourFormat(time) {
    const [timePart, ampm] = time.split(" ");
    const [hours, minutes] = timePart.split(":");
    let hour = parseInt(hours, 10);

    if (ampm === "PM" && hour < 12) {
      hour += 12;
    } else if (ampm === "AM" && hour === 12) {
      hour = 0;
    }

    return hour.toString().padStart(2, "0");
  }
  function createSchedule() {
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/automation/create-schedule/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setOpen3(false);
          setShowToaster(true);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function getShceduleData() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-schedule/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllSchedule(res.data.details);
          setAllScheduleCopy(res.data.details);
        } else {
          setAllSchedule([]);
          setAllScheduleCopy([]);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setSpinner(false);
      })
      .catch((err) => console.log("Error"));
  }
  function convertTo12HourFormat(hour) {
    // Check if the input is a valid number between 0 and 23
    if (typeof hour !== "number" || hour < 0 || hour > 23) {
      return "Invalid input";
    }

    // Convert 24-hour format to 12-hour format
    if (hour === 0) {
      return "12:00 AM";
    } else if (hour < 12) {
      return hour + ":00 AM";
    } else if (hour === 12) {
      return "12:00 PM";
    } else {
      return hour - 12 + ":00 PM";
    }
  }
  function deleteScheduleById() {
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/automation/delete-schedule/${
          userDetails && userDetails.details._id
        }/${selectedSchedule._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setOpen(false);
          setShowToaster(true);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function updateSchedule() {
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/update-schedule-days/${
          userDetails && userDetails.details._id
        }/${selectedScheduleId}`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setOpen3(false);
          setShowToaster(true);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  return (
    <div
      style={{
        height: "100%",
        overflowY: "scroll",
        // paddingLeft: "16px",
        // paddingRight: "16px",
        background: "#FFF",
        borderRadius: "6px",
        border: "1px solid #DDD",
      }}
    >
      <Helmet>
        <title>Schedules</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        className="allcampairnlistandfilters"
      >
        <div className="allcomponantcampaign">Schedules</div>

        <div style={{ display: "flex", gap: "12px" }}>
          <TextField
            autoComplete="off"
            onChange={(e) => {
              setSearchedVal(e.target.value);
            }}
            value={searchedVal}
            variant="standard"
            placeholder="Search"
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <div
                  style={{
                    display: "flex",
                    width: "16px",
                    height: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.66666 14C11.1645 14 14 11.1644 14 7.66665C14 4.16884 11.1645 1.33331 7.66666 1.33331C4.16886 1.33331 1.33333 4.16884 1.33333 7.66665C1.33333 11.1644 4.16886 14 7.66666 14Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 14.6666L13.3333 13.3333"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              ),

              sx: {
                display: "flex",
                padding: "6px 9px",
                alignItems: "center",
                gap: "10px",
                alignSelf: "stretch",
                borderRadius: "4px",
                border: "1px solid #1C485F",
                background: "var(--background-color, #FAFAFA)",
                width: "100%",
                "& input": {
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                },
              },
            }}
          />
          <div
            onClick={() => {
              setOpen3(true);
              setUpdateStatus(false);
            }}
            className="createCampaignfilledbutton"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M7.96875 15.9607V11.794"
                stroke="white"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.0026 13.8773H5.83594"
                stroke="white"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.66406 2.62735V5.12735"
                stroke="white"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.3359 2.62735V5.12735"
                stroke="white"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.1739 3.8107C15.9572 3.9107 17.3656 4.9357 17.4489 8.85237L17.5572 13.994C17.6239 17.4274 16.8322 19.1524 12.6656 19.244L7.66555 19.344C3.49889 19.4274 2.63222 17.7274 2.56555 14.3024L2.44889 9.15237C2.36555 5.2357 3.74055 4.15237 6.50722 3.94403L13.1739 3.8107Z"
                stroke="white"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Create Schedule
          </div>
        </div>
      </div>
      {spinner ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px",
            height: "40vh",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {allSchedule.length === 0 ? (
            <div
              style={{
                backgroundColor: "#fff",
                padding: "12px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={searchedVal.length > 0 ? nodata : scheduleNull}
                alt=""
                style={{ height: "42vh" }}
                loading="lazy"
              />
              <div className="scheduleboxindashboard">
                <div className="nocampaigncreated">
                  {searchedVal.length > 0
                    ? `No data found`
                    : `No schedules yet`}
                </div>
                <div className="createcampaiintext">
                  {searchedVal.length > 0
                    ? `There's no schedule that fits your search`
                    : `Create schedules consistent with your recipient's working
                  hours to increase your email engagement and emulate realistic
                  sending behavior.`}
                </div>
                <div
                  className="createCampaignfilledbutton"
                  onClick={() => {
                    setOpen3(true);
                    setUpdateStatus(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M7.96875 15.9607V11.794"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.0026 13.8773H5.83594"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.66406 2.62735V5.12735"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.3359 2.62735V5.12735"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.1739 3.8107C15.9572 3.9107 17.3656 4.9357 17.4489 8.85237L17.5572 13.994C17.6239 17.4274 16.8322 19.1524 12.6656 19.244L7.66555 19.344C3.49889 19.4274 2.63222 17.7274 2.56555 14.3024L2.44889 9.15237C2.36555 5.2357 3.74055 4.15237 6.50722 3.94403L13.1739 3.8107Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Create schedule
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  allSchedule.length !== 1
                    ? `repeat(auto-fit, minmax(500px, 1fr))`
                    : "min-content",
                gap: "16px",
                padding: "10px",
              }}
            >
              {allSchedule.map((val, idx) => (
                <div
                  className="scheduleboxdrawer grid-item"
                  onClick={() => {
                    setSelectedSchedule(val);
                  }}
                  key={idx}
                  style={{
                    boxShadow:
                      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                  }}
                >
                  <div className="shcedulelistbox">
                    {" "}
                    <div style={{ display: "flex" }}>{val.Name}</div>
                    <div className="shcedulerightsideicom">
                      {mouseEntered._id !== val._id ? (
                        <Tooltip title="Delete schedule" arrow>
                          <svg
                            onMouseEnter={() => {
                              setMouseEntered(val);
                            }}
                            onMouseLeave={() => {
                              setMouseEntered("");
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.08594 5.10232L7.26927 4.01065C7.4026 3.21899 7.5026 2.62732 8.91094 2.62732H11.0943C12.5026 2.62732 12.6109 3.25232 12.7359 4.01899L12.9193 5.10232"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.7057 8.57739L15.1641 16.9691C15.0724 18.2774 14.9974 19.2941 12.6724 19.2941H7.3224C4.9974 19.2941 4.9224 18.2774 4.83073 16.9691L4.28906 8.57739"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.60938 14.7107H11.3844"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.91406 11.3773H12.0807"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Delete schedule" arrow>
                          <svg
                            onClick={() => {
                              setOpen(true);
                              setSelectedSchedule(val);
                            }}
                            onMouseEnter={() => {
                              setMouseEntered(val);
                            }}
                            onMouseLeave={() => {
                              setMouseEntered("");
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.08594 4.14169L7.26927 3.05002C7.4026 2.25835 7.5026 1.66669 8.91094 1.66669H11.0943C12.5026 1.66669 12.6109 2.29169 12.7359 3.05835L12.9193 4.14169"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.7057 7.61664L15.1641 16.0083C15.0724 17.3166 14.9974 18.3333 12.6724 18.3333H7.3224C4.9974 18.3333 4.9224 17.3166 4.83073 16.0083L4.28906 7.61664"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.60938 13.75H11.3844"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.91406 10.4167H12.0807"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Tooltip>
                      )}
                      {mouseEntered2._id !== val._id ? (
                        <Tooltip title="Edit schedule" arrow>
                          <svg
                            onMouseEnter={() => {
                              setMouseEntered2(val);
                            }}
                            onMouseLeave={() => {
                              setMouseEntered2("");
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M9.16406 2.62732H7.4974C3.33073 2.62732 1.66406 4.29399 1.66406 8.46065V13.4607C1.66406 17.6273 3.33073 19.294 7.4974 19.294H12.4974C16.6641 19.294 18.3307 17.6273 18.3307 13.4607V11.794"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3675 3.47733L6.80088 10.044C6.55088 10.294 6.30088 10.7857 6.25088 11.144L5.89254 13.6523C5.75921 14.5607 6.40088 15.194 7.30921 15.069L9.81754 14.7107C10.1675 14.6607 10.6592 14.4107 10.9175 14.1607L17.4842 7.59399C18.6175 6.46066 19.1509 5.14399 17.4842 3.47733C15.8175 1.81066 14.5009 2.34399 13.3675 3.47733Z"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.4219 4.41907C12.9802 6.41073 14.5385 7.96907 16.5385 8.53573"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Edit schedule" arrow>
                          <svg
                            onClick={() => {
                              setOpen3(true);
                              setUpdateStatus(true);
                              setSelectedScheduleId(val._id);
                              setSelectedSchedule(val);
                              setScheduleName(val.Name);
                              console.log("selected", val);
                              setCountryTimeSchdule(val.TimeZone);
                              let vikki = val.Day;
                              vikki.map((value) => {
                                value.EndHour = convertTo12HourFormat(
                                  parseInt(value.EndHour)
                                );
                                value.StartHour = convertTo12HourFormat(
                                  parseInt(value.StartHour)
                                );
                                delete value._id;
                              });
                              console.log("vikki", vikki);
                              setDayListArr(vikki);
                            }}
                            onMouseEnter={() => {
                              setMouseEntered2(val);
                            }}
                            onMouseLeave={() => {
                              setMouseEntered2("");
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M9.16406 1.66669H7.4974C3.33073 1.66669 1.66406 3.33335 1.66406 7.50002V12.5C1.66406 16.6667 3.33073 18.3334 7.4974 18.3334H12.4974C16.6641 18.3334 18.3307 16.6667 18.3307 12.5V10.8334"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3675 2.51669L6.80088 9.08336C6.55088 9.33336 6.30088 9.82503 6.25088 10.1834L5.89254 12.6917C5.75921 13.6 6.40088 14.2334 7.30921 14.1084L9.81754 13.75C10.1675 13.7 10.6592 13.45 10.9175 13.2L17.4842 6.63336C18.6175 5.50003 19.1509 4.18336 17.4842 2.51669C15.8175 0.850027 14.5009 1.38336 13.3675 2.51669Z"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.4219 3.45831C12.9802 5.44998 14.5385 7.00831 16.5385 7.57498"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div
                    className="shedulednametext"
                    style={{ border: "1px solid #1C485F" }}
                  >
                    {val.TimeZone}
                  </div>
                  <div className="weeknameslist">
                    {val.Day.map((value) => {
                      return (
                        <div className="nameandticked2">
                          {" "}
                          {!value.Active ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 25"
                              fill="none"
                            >
                              <rect
                                x="0.5"
                                y="1.46069"
                                width="23"
                                height="23"
                                rx="3.5"
                                fill="white"
                                stroke="#1C485F"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 25 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.25"
                                width="24"
                                height="24"
                                rx="4"
                                fill="#1C485F"
                              />
                              <path
                                d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          )}{" "}
                          {value.Day}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {showToaster && <ToastContainer />}
      <Drawer placement={"right"} open={open3} onClose={handleClose} size="sm">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            style={{
              padding: "10px 16px",
              borderBottom: "1px solid #DDD",
              flexShrink: 0,
            }}
          >
            <p
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
                color: "#4B4B4B",
              }}
            >
              Add New schedule
            </p>
          </div>
          <div
            style={{
              flexGrow: 1,
              overflowY: "scroll",
              backgroundColor: "Background",
              padding: "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                padding: "12px",
                borderRadius: "12px",
                // boxShadow:
                //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <label
                htmlFor="schedule"
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4B4B4B",
                }}
              >
                Schedule name
              </label>
              <input
                value={shceduleName}
                onChange={(e) => {
                  setScheduleName(e.target.value);
                }}
                id="schedule"
                type="text"
                autoComplete="off"
                style={{
                  border: "1px solid #1C485F",
                  padding: "12px 12px",
                  backgroundColor: "#FAFAFA",
                  outline: "none",
                  borderRadius: "4px",
                }}
                placeholder="Ex:New schedule"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                padding: "12px",
                borderRadius: "12px",
                // boxShadow:
                //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4B4B4B",
                }}
              >
                Country time
              </p>
              <Autocomplete
                displayEmpty
                variant="standard"
                value={countryTimeSchedule}
                disableUnderline
                options={timezoneArr}
                onChange={handleChange9}
                sx={{
                  backgroundColor: "#FAFAFA",

                  borderRadius: "4px",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4B4B4B",
                  maxHeight: 160,
                  overflowY: "auto",
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#eee",
                    },
                }}
                renderInput={(params) => (
                  <TextField
                    placeholder="Choose country time"
                    sx={{
                      outline: "none",
                    }}
                    {...params}
                  />
                )}
                inputProps={{ "aria-label": "Without label" }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      height: 160,
                      overflowY: "auto",
                    },
                  },
                }}
              ></Autocomplete>
              <div>
                <div className="shceduledayfrombox">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3,1fr)",
                      gap: "16px",
                      marginTop: "13px",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontStyle: "normal",
                        color: "#4B4B4B",
                        fontWeight: 700,
                        width: "155px",
                      }}
                    >
                      Days
                    </div>
                    <div
                      style={{
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontStyle: "normal",
                        color: "#4B4B4B",
                        fontWeight: 700,
                      }}
                    >
                      From
                    </div>
                    <div
                      style={{
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontStyle: "normal",
                        color: "#4B4B4B",
                        fontWeight: 700,
                      }}
                    >
                      To
                    </div>
                  </div>
                  <div className="weeksdaysbox">
                    {daylistArr.map((val, idx) => {
                      return (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3,1fr)",
                            gap: "16px",
                          }}
                        >
                          <FormControlLabel
                            sx={{ width: "150px" }}
                            value={val.Day}
                            control={
                              <Checkbox
                                checked={val.Active}
                                style={{
                                  color: "#1C485F",
                                }}
                              />
                            }
                            label={val.Day}
                            onClick={(e) => {
                              val.Active = !val.Active;
                              setDayListArr([...daylistArr]);
                            }}
                          />
                          <FormControl size="medium" sx={{ width: "100%" }}>
                            <Select
                              displayEmpty
                              variant="standard"
                              disableUnderline
                              value={val.StartHour}
                              onChange={(e) => {
                                val.StartHour = e.target.value;
                                setDayListArr([...daylistArr]);
                              }}
                              sx={{
                                outline: "none",
                                backgroundColor: "#FAFAFA",
                                padding: "6px 0px 6px 6px",
                                opacity: !val.Active && "0.3",
                                pointerEvents: !val.Active && "none",
                                border: "1px solid #1c485f",
                                borderRadius: "4px",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#4B4B4B",
                              }}
                              renderValue={(selected) => {
                                if (selected.length === 0) {
                                  return (
                                    <em
                                      style={{
                                        fontStyle: "normal",
                                        fontSize: "14px",
                                        color: "#888888",
                                      }}
                                    >
                                      Choose country time
                                    </em>
                                  );
                                }
                                return selected;
                              }}
                              inputProps={{ "aria-label": "Without label" }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 160,
                                  },
                                },
                              }}
                            >
                              {timeList.map((name, index) => (
                                <MenuItem
                                  disableRipple
                                  disableTouchRipple
                                  key={index}
                                  value={name}
                                  sx={{
                                    borderBottom:
                                      timezoneArr.length !== index + 1 &&
                                      "1px solid #DDD",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    color: "#838383",
                                    padding: "12px",
                                  }}
                                >
                                  {name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl size="medium" sx={{ width: "100%" }}>
                            <Select
                              displayEmpty
                              variant="standard"
                              disableUnderline
                              value={val.EndHour}
                              onChange={(e) => {
                                val.EndHour = e.target.value;
                                setDayListArr([...daylistArr]);
                              }}
                              sx={{
                                outline: "none",
                                backgroundColor: "#FAFAFA",
                                opacity: !val.Active && "0.3",
                                pointerEvents: !val.Active && "none",
                                border: "1px solid #1c485f",
                                padding: "6px 0px 6px 6px",
                                borderRadius: "4px",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#4B4B4B",
                              }}
                              renderValue={(selected) => {
                                if (selected.length === 0) {
                                  return (
                                    <em
                                      style={{
                                        fontStyle: "normal",
                                        fontSize: "14px",
                                        color: "#888888",
                                      }}
                                    >
                                      Choose country time
                                    </em>
                                  );
                                }
                                return selected;
                              }}
                              inputProps={{ "aria-label": "Without label" }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 160,
                                  },
                                },
                              }}
                            >
                              {timeList.map((name, index) => (
                                <MenuItem
                                  disableRipple
                                  disableTouchRipple
                                  key={index}
                                  value={name}
                                  sx={{
                                    borderBottom:
                                      timezoneArr.length !== index + 1 &&
                                      "1px solid #DDD",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    color: "#838383",
                                    padding: "12px",
                                  }}
                                >
                                  {name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-start",
              borderTop: "1px solid #DDD",
              flexShrink: 0,
              padding: "10px 16px",
            }}
          >
            <div
              onClick={() => {
                setOpen3(false);
                setScheduleName("");
                setCountryTimeSchdule(null);
              }}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#1C485F",
                backgroundColor: "transparent",
                border: "1px solid #1C485F",
                borderRadius: "6px",
                padding: "8px 18px",
                cursor: "pointer",
              }}
            >
              Cancel
            </div>
            <button
              onClick={() => {
                if (updateStatus) {
                  updateSchedule();
                } else {
                  createSchedule();
                }
                setScheduleName("");
                setCountryTimeSchdule(null);
              }}
              disabled={countryTimeSchedule === null || shceduleName === ""}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#FFF",
                outline: "none",
                borderRadius: "6px",
                padding: "8px 24px",
                // opacity:countryTimeSchedule!==null && shceduleName!== "" && daylistArr.some(item => item.Active === true) ? 1 : 0.4
              }}
              className="bg-primary"
            >
              {updateStatus ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </Drawer>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Confirm Delete</div>
          <div className="modalsubtext">
            Are you sure you want to delete this schedule?
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                deleteScheduleById();
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={open2}
        onClose={() => {
          setOpen2(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopup" style={{ width: window.innerWidth / 1.9 }}>
          <div className="modaltext">Let's create a new campaign</div>
          <div className="modalsubtext">What would you like to name it?</div>

          <div className="modalmoxtextlabel">Campaign Name</div>
          <TextField
            autoComplete="off"
            value={campaignName}
            onChange={(e) => {
              setCampaignName(e.target.value);
            }}
            variant="standard"
            placeholder="Ex:My Campaign"
            InputProps={{
              disableUnderline: true,

              sx: {
                display: "flex",
                padding: "10px 16px",
                alignItems: "center",
                gap: "10px",
                borderRadius: "4px",
                border: "1px solid #1C485F",
                background: "var(--background-color, #FAFAFA)",
                width: window.innerWidth / 2.04,
                "& input": {
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                },
              },
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "32px",
              width: window.innerWidth / 2.04,
            }}
          >
            <div style={{ alignItems: "center", display: "flex", gap: "10px" }}>
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen2(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  history.push("/All-Campaign/New-Campaign", {
                    campaignName: campaignName,
                    from: "new",
                  });
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
